import React from 'react';
import { Root, createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import App from './App';

if (process.env.GTM_ID) {
    TagManager.initialize({
        gtmId: process.env.GTM_ID,
    });
}

const root: Root = createRoot(document.getElementById('root'));
root.render(<App />);
